export const validation = {
  cookiesPolicy: "Please Enter Cookies Policy",
};
